"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 11px;\n  right: 15px;\n  font-size: 0px;\n  z-index: 1;\n"], ["\n  position: absolute;\n  top: 11px;\n  right: 15px;\n  font-size: 0px;\n  z-index: 1;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div.withConfig({
  displayName: "searchIcon__Container",
  componentId: "sc-1eg3ozv-0"
})(_templateObject);

var SearchIcon = function SearchIcon(props) {
  return _react2.default.createElement(
    Container,
    props,
    _react2.default.createElement(
      "svg",
      { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 14 15" },
      _react2.default.createElement("path", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "#939393",
        strokeLinecap: "round",
        d: "M3.575 7.712a5.38 5.38 0 0 1-.218-2.22c.249-2.295 1.998-4.161 4.176-4.45  3.165-.42 5.826 2.38 5.427 5.71-.276 2.304-2.068 4.15-4.263 4.398a4.645  4.645 0 0 1-3.082-.731.226.226 0 0 0-.29.032L1 15"
      })
    )
  );
};

exports.default = SearchIcon;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-autosuggest/dist/images/searchIcon.js
// module id = 388
// module chunks = 168707334958949